module.exports = __webpack_public_path__ + "img/schema_verticalisateur_3b.69758ba2.svg";